<label class="form-label text-nowrap mb-0">Door Rate</label>
<div class="input-group">
  <span class="input-group-text">$</span>
  <input class="form-control" type="number" [readOnly]="claimDto!.isLocked" [(ngModel)]="claimDto!.repairCentre.doorRate">
  <span class="input-group-text">/hour</span>
</div>
